import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { useTranslation } from 'react-i18next';

export function OrDivider() {
  const { t } = useTranslation(undefined, { keyPrefix: 'checkout' });
  return (
    <Box mt={1.5} mb={0.25}>
      <Divider>
        <Box className="or-divider-text" fontSize={12} fontWeight={500}>
          {t('orPayAnotherWay')}
        </Box>
      </Divider>
    </Box>
  );
}
